import script from "./HerramientaTaller.vue?vue&type=script&setup=true&lang=js"
export * from "./HerramientaTaller.vue?vue&type=script&setup=true&lang=js"

import "./HerramientaTaller.vue?vue&type=style&index=0&id=3301fdca&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3301fdca"]])

export default __exports__